export default __webpack_public_path__ + "static/product-liability-0ce3746e4aab1f0aa3479e4930a2706a.jpg";